module.exports = __webpack_public_path__ + "static/media/refrigeratorCorrect.7dd286a5.png";